module.exports = __webpack_public_path__ + "img/eng-lang-flag.47f6e045.png";